import React from 'react';
import { AppBreadcrumb } from './AppBreadcrumb';
import type { Crumb } from './AppBreadcrumb';

export type PageBreadcrumbProps = {
  items: Crumb[];
  onBack?: () => void;
  variant?: 'mui' | 'bootstrap';
  className?: string;
  id?: string;
};

/**
 * Breadcrumb de página com botão "Voltar" opcional ao lado do último nível.
 */
export function PageBreadcrumb({
  items,
  onBack,
  variant = 'bootstrap',
  className,
  id,
}: PageBreadcrumbProps): React.ReactElement {
  return (
    <div
      id={id}
      className={className}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '0.5rem',
      }}
    >
      <AppBreadcrumb items={items} variant={variant} />
      {onBack && (
        <button
          type="button"
          className="btn btn-outline-secondary btn-sm"
          onClick={onBack}
          aria-label="Voltar"
        >
          ← Voltar
        </button>
      )}
    </div>
  );
}
